import { render } from "./stockTab.vue?vue&type=template&id=614a380a"
import script from "./stockTab.vue?vue&type=script&lang=ts"
export * from "./stockTab.vue?vue&type=script&lang=ts"

import "./stockTab.vue?vue&type=style&index=0&id=614a380a&lang=scss"
script.render = render

export default script